




export const eTypeString: string[] = ["", "Premiere", "Standard", "Plus"];





export enum ETypeNum
{
    Premiere = 1,
    Standard = 2,
    Plus = 3
}





export interface EType
{
    id: number,
    name: string
}